import { FeatureFlagIds } from 'helpers/featureFlags';
import { RootState } from '../reducer';
import { FeatureFlag } from './reducer';

export const getFeatureFlags = (state: RootState) => state.featureFlags;
export const getFeatureFlag = (state: RootState, id: FeatureFlagIds): FeatureFlag | undefined => state.featureFlags.find((flag) => flag.id === id);
export const isFeatureFlagActive = (state: RootState, id: FeatureFlagIds): boolean => getFeatureFlag(state, id)?.isActive ?? false;
